import globals from '../../styles/globals';

export default (theme) => ({
    ...globals(theme),
    fanItem: {
        backgroundColor: theme.palette.background.default
    },
    media: {
        height: 200
    },
    img: {
        objectFit: 'contain'
    }
});
